import { observer } from 'mobx-react-lite';
import { useMainContext } from '../hooks/useMainContext';
import { useEffect } from 'react';
import { handleKeyDown, handleWheel } from '../utils/uiUtils';
import Header from '../components/Homepage/Header';
import { PageTypes } from '../config';
import HomeDashboard from '../components/Homepage/HomeDashboard';
import NewWorkspace from '../components/WorkSpace/NewWorkspace/NewWorkspace';

const Viewer = observer(() => {
    const { viewManager } = useMainContext();
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('wheel', handleWheel);
        };
    }, []);
    return (
        <div className="h-[100dvh] w-full">
            <Header />
            <div className="h-[calc(100dvh-80px)] flex w-full ">
                {viewManager.currentPage === PageTypes.WorkSpace && (
                    <NewWorkspace />
                )}
                {viewManager.currentPage === PageTypes.HomePage && (
                    <HomeDashboard />
                )}
            </div>
        </div>
    );
});

export default Viewer;
